/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Error_ContinueInputs */

const en_validation_error_continue = /** @type {(inputs: Validation_Error_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue anyway`)
};

const nl_validation_error_continue = /** @type {(inputs: Validation_Error_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toch doorgaan`)
};

/**
* | output |
* | --- |
* | "Continue anyway" |
*
* @param {Validation_Error_ContinueInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const validation_error_continue = /** @type {((inputs?: Validation_Error_ContinueInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Error_ContinueInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_validation_error_continue(inputs)
	return en_validation_error_continue(inputs)
});